export const SET_SETTING = 'SET_SETTING';
